import { render, staticRenderFns } from "./OfertaForm.vue?vue&type=template&id=a9d82506&scoped=true&"
import script from "./OfertaForm.vue?vue&type=script&lang=js&"
export * from "./OfertaForm.vue?vue&type=script&lang=js&"
import style0 from "./OfertaForm.vue?vue&type=style&index=0&id=a9d82506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d82506",
  null
  
)

export default component.exports